<template>
  <!-- HEADER SUPERIOR A 991 -->
  <header class="headerBistro" v-if="!mobile">
    <!-- LOGOTIPO -->

    <article class="logo">
      <a :href="getLogoHRefUrl">
        <!-- <img src="~assets/img/logo_header.png" alt=""> -->
        <LogoSwitcher :type="'1'" :width="'166px'" :height="'57px'" />
      </a>
    </article>

    <!-- NAVEGACION -->
    <nav>
      <ul>
        <li v-for="item in options.filter(
          (x) => x.show && hasToShowThisOption(x.id)
        )" :key="item.id" :class="{ active: isActive(item)}">
          <router-link class="button" :to="item.url" :data-testid="navTestIds[item.url]">
            <p>{{ item.title }}</p>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- OPCIONES DE USUARIO -->
    <article class="user">
      <a href="#" class="dropdown-trigger userDropdown" data-target="dropdown-user" data-testid="user-dropdown">
        <div class="item">
          <h3 data-testid="welcome-header">Hola</h3>
          <p v-if="user?.user !== undefined || userData">{{ user?.user?.name ? user.user.name :  userData?.user?.name}}</p>
        </div>

        <figure>
          <img src="@/assets/img/comandos-avatar.webp" alt="" />
        </figure>

        <article class="version">v{{ version }}</article>
      </a>

      <!-- Dropdown Structure -->
      <ul id="dropdown-user" class="dropdown-content dropUser">
        <li v-if="hasToShowSettingsPosTab">
          <router-link to="/settingsPos">Configuraciones</router-link>
        </li>
        <li v-else-if="hasToShowThisOption(8)">
          <router-link to="/settingsV2">Configuraciones</router-link>
        </li>
        <li v-if="hasToShowMyPayments">
          <router-link to="/myPayments">Mis Pagos</router-link>
        </li>
        <li v-if="isArgentinaInstance && hasToShowMyAccount && isNotPdsUsers">
          <router-link to="/myAccount">Mi Cuenta</router-link>
        </li>
        <li v-if="hasToShowThisOption(7) && !hasToShowItemPosTab">
          <router-link to="/eventsV2">Auditoría de Cambios</router-link>
        </li>
        <li v-if="this.showChangePassword">
          <router-link to="/password">Contraseña</router-link>
        </li>
        <li>
          <a href="#" @click="logout" data-testid="btn-logout">Cerrar Sesión</a>
        </li>
      </ul>
    </article>
  </header>

  <!-- HEADER INFERIOR A 991 -->
  <header v-else class="headerMobile" :class="{ 'height-without-comerce-selector': isOnIntegrationsPage }">
    <div class="headerMobile-container">
      <!-- LOGOTIPO -->
      <article class="logogroup">
        <!-- LOGOTIPO -->
        <article class="logo">
          <a :href="getLogoHRefUrl">
            <img src="@/assets/img/logo_header.png" alt="">
            <Logo type="1" />
          </a>
        </article>
      </article>
      <!-- SUBMENU -->
      <article class="submenu">
        <article v-if="!drawer" class="optionMobileHeader">
          <!-- FILTRADO GENERAL -->
          <section v-if="showMerchantSelectionFilter && !elements.hideFilters" class="filterPDV">
            <!-- ENLACE A DROPDOWN -->
            <a v-if="showMerchantSelectionFilter" href='#' class="filterPDV-link" @click="showGeneralFilter">
              <figure :class="selectedPdvs?.length > 0 ? 'mobile-filter-applied' : ''">
                <p>+</p>
              </figure>
            </a>
            <div v-if="hasToShowGeneralFilter" class="dropdown-click-listener" @click="hasToShowGeneralFilter = false">
            </div>
            <!-- Dropdown Structure -->
            <transition name="fade">
              <ul :class="dropdownClassSelector" v-if="hasToShowGeneralFilter">
                <p :class="dropdownOptionClassSelector" @click="unselectAllShopFilter">Desmarcar todos</p>
                <hr class="dropdown-line">
                <li v-for="item in sortMerchantTagList(merchantTags)" :key="`${item.shopCode}`" @click="selectPdv(item)"
                  class="dropdown-item-container"
                  :class="{ 'dropdown-item-container--suspended': item.isSuspended === true }">
                  <input class="bistro-checkbox shop-filter-checkbox" type="checkbox" style="opacity: 1;"
                    v-model="item.selected" />
                  <div class="dropdown-item-text">
                    <h4 :ref="`merchantName_${item.shopCode}`" class="dropdown-truncate-text"
                      :title="getMerchantNameForDropdown(item.shopCode, item.merchantName)">
                      <span v-if="item.isSuspended === true" class="mdi mdi-alert-outline suspended-shop-icon"
                        title="Comercio suspendido"></span>
                      {{ item.merchantName }}
                    </h4>
                    <p>{{ item.shopCode }}</p>
                  </div>
                </li>
              </ul>
            </transition>
          </section>
        </article>
        <a class="active">
          <span v-if="drawer" @click="drawer = !drawer" class="icon-Bistro-_Close drawer"></span>
          <figure v-if="!drawer" @click="drawer = !drawer" class="icon-menu-white"></figure>
        </a>
      </article>
    </div>

    <!-- FILTRO TABS MOBILE -->
    <article v-if="!elements.hideTabs || showIntegrationsListSelectionFilter" :class="{ active: showTabs }" class="tabsMobile">
      <h3>Filtrado Rápido</h3>
      <!-- TABS -->
      <ShopFilter />

      <!-- BTN ACTIVE FILTER MOBILE -->
      <button v-if="!showProductListSelectionFilter && !showProviderListSelectionFilter && !showIntegrationsListSelectionFilter
      " @click="showTabs = !showTabs" class="btnFilterMobile">
        <p>{{ tabSelected.title }}</p>
      </button>

      <!-- BTN ACTIVE FILTER MOBILE -->
      <button v-if="showProviderListSelectionFilter" @click="showTabs = !showTabs" class="btnFilterMobile">
        <p>{{ providerTabSelected.title }}</p>
      </button>

      <!-- BTN ACTIVE FILTER MOBILE -->
      <button v-if="showProductListSelectionFilter" @click="showTabs = !showTabs" class="btnFilterMobile">
        <p>{{ stockTabSelected.title }}</p>
      </button>

      <button v-if="showIntegrationsListSelectionFilter" @click="showTabs = !showTabs" class="btnFilterMobile">
        <p>{{ integrationsTabsSelected.title }}</p>
      </button>
    </article>

    <div v-if="drawer" @click="drawer = !drawer" :class="{ 'overlay-drawer': drawer }"></div>
    <!-- NAV MOBILE -->
    <nav :class="{ active: drawer, activeNav: drawer }">
      <ul>
        <li @click="drawer = false">
          <router-link v-if="hasToShowThisOption(0) && !hasToShowProductsPosTab" 
          to="/productsV2" :class="{ active: option === 0 && !isDashboardActive && !showSellsAndReports && !showSettings }">
            <p>PRODUCTOS</p>
          </router-link>
          <router-link v-else-if="hasToShowThisOption(11) && hasToShowProductsPosTab"
          to="/productsPdv" :class="{ active: option === 11 && !isDashboardActive && !showSellsAndReports && !showSettings }" data-testid="nav-productos">
            <p>PRODUCTOS</p>
          </router-link>
        </li>
        <li v-if="hasToShowThisOption(2)" @click="showSellsAndReports = !showSellsAndReports, showSettings = false" >
          <!-- <router-link to="/dashboard/indexV2" :class="{ active: isDashboardActive }">
            <p>VENTAS Y REPORTES</p>
          </router-link> -->
          <div :class="{ headerActive:  showSellsAndReports && !showSettings}" >

            <p>VENTAS Y REPORTES</p>
          </div>
        </li>


        <li v-if="hasToShowThisOption(2) && showSellsAndReports" @click="drawer = false" :class="['li-children', { 'li-children-active': optionDashboard === 0 }]">
          <router-link to="/dashboard/indexV2" :class="{ 'active-2': optionDashboard === 0 }" class="new-child">
            <p>Tablero</p>
          </router-link>
        </li>

        <li v-if="hasToShowThisOption(2) && !hasToShowCashPosTab && showSellsAndReports" @click="drawer = false" :class="['li-children', { 'li-children-active': optionDashboard === 1 }]">
          <router-link to="/dashboard/consolidatedV2"
            :class="{ 'active-2': optionDashboard === 1 }" class="new-child">
            <p>Consolidado</p>
          </router-link>
        </li>

        <li v-if="hasToShowItemPosTab && showSellsAndReports" @click="drawer = false" :class="['li-children', { 'li-children-active': optionDashboard === 1 }]">
          <router-link to="/dashboard/consolidatedPos"
            :class="{ 'active-2': optionDashboard === 1 }" class="new-child">
            <p>Consolidado</p>
          </router-link>
        </li>

        <li v-if="showBillingPage && hasToShowThisOption(2) && hasToShowBillingPosTab && showSellsAndReports" @click="drawer = false" :class="['li-children', { 'li-children-active': optionDashboard === 2 }]">
          <router-link to="/dashboard/billingDetail"
            :class="{ 'active-2': optionDashboard === 2 }" class="new-child">
            <p>Facturación</p>
          </router-link>
        </li>

        <li v-if="hasToShowThisOption(2) && showSellsAndReports" @click="drawer = false" :class="['li-children', { 'li-children-active': optionDashboard === 3 }]">
          <router-link :to="hasToShowReportPosTab ? '/dashboard/reportPDV' : '/dashboard/report'"
            :class="{ 'active-2': optionDashboard === 3 }" class="new-child">
            <p>Reportes</p>
          </router-link>
        </li>

        <li v-if="hasToShowThisOption(2) && showSellsAndReports && hasToShowIntegrationsTab" @click="drawer = false" :class="['li-children', { 'li-children-active': optionDashboard === 4 }]">
          <router-link :to="'/dashboard/integrations'"
            :class="{ 'active-2': optionDashboard === 4 }" class="new-child">
            <p>Gestor de delivery</p>
          </router-link>
        </li>

        <li @click="drawer = false">
          <router-link v-if="hasToShowThisOption(1) && !hasToShowItemPosTab" to="/clientsV2" :class="{ active: option === 1 && !showSellsAndReports && !showSettings}">
            <p>CLIENTES</p>
          </router-link>
        </li>


        <li @click="drawer = false">
          <router-link v-if="hasToShowThisOption(3) && !hasToShowItemPosTab" to="/providersV2" :class="{ active: option === 3 && !showSellsAndReports && !showSettings}">
            <p>PROVEEDORES</p>
          </router-link>
        </li>

        <li @click="drawer = false">
          <router-link v-if="hasToShowThisOption(5) && !hasToShowCashPosTab"
            to="/box" :class="{ active: option ===  5 && !showSellsAndReports && !showSettings}">
            <p>CAJA</p>
          </router-link>
          <router-link v-if="hasToShowThisOption(10) && hasToShowCashPosTab"
            to="/boxPos" :class="{ active: option ===  10 && !showSellsAndReports && !showSettings}" data-testid="nav-caja">
            <p>CAJA</p>
          </router-link>
        </li>

        <li @click="drawer = false">
          <router-link v-if="hasToShowThisOption(6)" to="/usersV2" :class="{ active: option === 6 && !showSellsAndReports && !showSettings}">
            <p>USUARIOS</p>
          </router-link>
        </li>

        <li @click="drawer = false">
          <router-link v-if="hasToShowThisOption(9)" to="/pdv/orders" :class="{ active: option === 7 && !showSellsAndReports && !showSettings}" data-testid="nav-pdv">
            <p>PDV</p>
          </router-link>
        </li>
        <li @click="showSettings = !showSettings, showSellsAndReports = false">
          <div class="config-container" :class="{ headerActive:  showSettings}">
            <figure>
              <img src="@/assets/img/comandos-avatar.webp" alt="" />
            </figure>
            <p>{{ currentEmail }}</p>
          </div>
        </li>
        <li v-if="showSettings">
          <a href="/"></a>
        </li>
        <li @click="drawer = false" v-if="hasToShowSettingsPosTab && showSettings"  :class="['li-children', { 'li-children-active': isSettingsPosActive}]">
          <router-link to="/settingsPos" :class="{ 'active-2': isSettingsPosActive }" class="new-child">
            <p>Configuraciones</p>
          </router-link>
        </li>
        <li @click="drawer = false" v-else-if="hasToShowThisOption(8) && showSettings" :class="['li-children', { 'li-children-active': isSettingsV2Active}]">
          <router-link to="/settingsV2" :class="{ 'active-2': isSettingsV2Active }" class="new-child">
            <p>Configuraciones</p>
          </router-link>
        </li>
        <li @click="drawer = false" v-if="hasToShowMyPayments && showSettings" :class="['li-children', { 'li-children-active': isMyPaymentsActive}]">
          <router-link to="/myPayments" :class="{ 'active-2': isMyPaymentsActive }" class="new-child">
            <p>Mis Pagos</p>
          </router-link>
        </li>
        <li @click="drawer = false" v-if="isArgentinaInstance && showSettings && hasToShowMyAccount" :class="['li-children', { 'li-children-active': isMyAccountActive}]">
          <router-link to="/myAccount" :class="{ 'active-2': isMyAccountActive }" class="new-child">
            <p>Mi Cuenta</p>
          </router-link>
        </li>
        <li @click="drawer = false" v-if="hasToShowThisOption(7) && !hasToShowItemPosTab && showSettings" :class="['li-children', { 'li-children-active': isEventsV2Active}]">
          <router-link to="/eventsV2" :class="{ 'active-2': isEventsV2Active }" class="new-child">
            <p>Auditoría de Cambios</p>
          </router-link>
        </li>
        <li @click="drawer = false" v-if="this.showChangePassword && showSettings" :class="['li-children', { 'li-children-active': isPasswordActive}]">
          <router-link to="/password" :class="{ 'active-2': isPasswordActive }" class="new-child">
            <p>Contraseña</p>
          </router-link>
        </li>
        <li v-if="showSettings" class="li-children">
          <router-link to="#" @click="logout" class="new-child" data-testid="btn-logout">
            <p>Cerrar Sesión</p>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- CALENDARIO -->
    <article v-if="!elements.hideCalendar" class="headerOptions">
      <section class="calendar">
        <div class="calendar-title">
          <figure>
            <span class="icon-Bistro-_calendar"></span>
          </figure>
          <div class="datepicker-trigger">
            <h3 @click="showCalendar" id="datepicker-trigger">{{ date }}</h3>
          </div>
        </div>
      </section>
    </article>

    <MerchantSelectionFilter v-if="showProductListSelectionFilter && !isShowingCentralizedStock"
      :optionList="productLists" @onSelectOption="onProductsListChanged" />

    <MerchantSelectionFilter v-if="showProviderListSelectionFilter" :optionList="providerLists"
      @onSelectOption="onProvidersListChanged" />

    <MerchantSelectionFilter v-if="showMenuEngineeringListSelectionFilter" :optionList="menuEngineeringLists"
      @onSelectOption="onMenuEngineeringListChanged" />

    <MerchantSelectionFilter v-if="showMyAccountListSelectionFilter" :optionList="myAccountLists"
        @onSelectOption="onMyAccountListChanged" />

    <MerchantSelectionFilter v-if="showUserListSelectionFilter" :optionList="userList"
      @onSelectOption="onUserListChanged" />

    <MerchantSelectionFilter v-if="showSettingListSelectionFilter" :optionList="settingList"
      @onSelectOption="onSettingListChanged" />

    <MerchantSelectionFilter v-if="showClientListSelectionFilter" :optionList="clientList"
      @onSelectOption="onCustomerListChanged" />

    <MerchantSelectionFilter v-if="showPDVListSelectionFilter" :optionList="PDVList"  @onSelectOption="onPDVListChanged"
    /> 
  </header>
</template>
<script>
import mixCommons from "../mixins/mixCommons";
import headerCommons from "../mixins/headerCommons";
import providerCommons from "../mixins/providerCommons";
import stockV2Commons from "../mixins/stockV2Commons";
import rolesCommons from "../mixins/rolesCommons";
import integrationsCommons from "../mixins/integrationsCommons";
import mixTester from "../mixins/mixTester";
import $ from "jquery";
import ShopFilter from "../components/ShopFilter";
import LogoSwitcher from "../components/logos/LogoSwitcher";
import instanceCommons from "@/mixins/instanceCommons.vue";

import MerchantSelectionFilter from "../components/MerchantSelectionFilter";
import moment from "moment";
import pjson from "../../package.json";
import { useRoles } from "@/features/composables/useRoles";
moment.locale("es");

export default {
  components: {
    ShopFilter,
    LogoSwitcher,
    MerchantSelectionFilter,
  },
  mixins: [
    mixCommons,
    stockV2Commons,
    providerCommons,
    headerCommons,
    rolesCommons,
    integrationsCommons,
    mixTester,
    instanceCommons
  ],
  data() {
    return {
      hasToShowGeneralFilter: false,
      showSellsAndReports: false,
      showSettings: false,
      drawer: false,
      showTabs: false,
      navTestIds: {
        '/pdv/orders': 'nav-pdv',
        '/boxPos': 'nav-caja',
        '/box': 'nav-caja',
        '/productsPdv': 'nav-productos',
        '/productsV2': 'nav-productos',
        '/dashboard/indexV2': 'nav-ventas',
      },
      version: pjson.version, // 'v1.13',
      dateFormat: "D MMM",
      dateOne: "",
      dateTwo: "",
      options: [
        {
          id: 0,
          title: "PRODUCTOS",
          url: "/productsV2",
          show: true
        },
        {
          id: 11,
          title: "PRODUCTOS",
          url: "/productspdv",
          show: false,
        },
        {
          id: 2,
          title: "VENTAS Y REPORTES",
          url: "/dashboard/indexV2",
          show: true,
          childs: [
            {
              title: "Tablero",
              url: "/dashboard/indexV2",
              icon: "icon-Bistro-_Dashboard",
              show: true,
            },
            {
              title: "Consolidado",
              url: "/dashboard/consolidatedV2",
              icon: "icon-Bistro-_Comandas",
              show: true,
            },
            {
              title: "Consolidado",
              url: "/dashboard/consolidatedPos",
              icon: "icon-Bistro-_Comandas",
              show: true,
            },
            {
              title: "Facturación",
              url: "/dashboard/billingDetail",
              icon: "icon-Bistro-_TDC",
              show: false,
            },
            {
              title: "Reportes",
              url: "/dashboard/report",
              icon: "icon-Bistro-_FileDoble",
              show: false,
            },
            {
              title: "Reportes",
              url: "/dashboard/reportPDV",
              icon: "icon-Bistro-_FileDoble",
              show: false,
            },
            {
              title: "Gestor de delivery",
              url: "/dashboard/integrations",
              icon: "icon-Bistro-_Moto",
              show: false,
            },
          ],
        },
        {
          id: 1,
          title: "CLIENTES",
          url: "/clientsV2",
          show: true
        },
        {
          id: 3,
          title: "PROVEEDORES",
          url: "/providersV2",
          show: true
        },
        {
          id: 5,
          title: "CAJA",
          url: "/box",
          show: true
        },
        {
          id: 10,
          title: "CAJA",
          url: "/boxPos",
          show: false
        },
        {
          id: 6,
          title: "USUARIOS",
          url: "/usersV2",
          show: true
        },
        {
          id: 9,
          title: "PDV",
          url: "/pdv/orders",
          show: false,
        },
      ],
      showChangePassword: true,
      userData:[]
    };
  },
  computed: {
    isSettingsPosActive() {
      return this.$route.path === '/settingsPos';
    },
    isSettingsV2Active() {
      return this.$route.path === '/settingsV2';
    },
    isMyPaymentsActive() {
      return this.$route.path === '/myPayments';
    },
    isMyAccountActive() {
      return this.$route.path === '/myAccount';
    },
    isEventsV2Active() {
      return this.$route.path === '/eventsV2';
    },
    isPasswordActive() {
      return this.$route.path === '/password';
    },
    isDashboardTabActive() {
      return (
        this.optionDashboard === 0 ||
        this.optionDashboard === 1 ||
        this.optionDashboard === 2 ||
        this.optionDashboard === 3 || 
        this.optionDashboard === 4 
      );
    },
    selectedProvidersList() {
      if (this.providerLists[0] && !this.$store.getRefreshProviderList) {
        this.onProvidersListChanged(this.providerLists[0].shopCode);
        return this.providerLists[0].shopCode;
      }
      return this.$store.getRefreshProviderList;
    },
    option() {
      return this.$store.getTopMenu;
    },
    optionDashboard() {
      if(!this.$route.path.startsWith('/dashboard/')) return false
      return this.$store.getSideMenu;
    },
    dropdownClassSelector() {
      return {
        'dropdown-filter': true,
        'filterPDV-dropdown': true,
        'dropdown-filter-show': this.hasToShowGeneralFilter,
      };
    },
    dropdownOptionClassSelector() {
      return {
        'dropdown-options': true,
        'dropdown-options-active': this.selectedPdvs?.length > 0,
      };
    },
    hasToShowMyPayments() {
      if (process.env.VUE_APP_INSTANCE_CODE === 'MX') {
        return true
      } else {
        return false
      }
    },
    isDashboardActive() {
      return this.$route.path.startsWith('/dashboard/')
    },
    currentEmail(){
      return this.$store.getAuthUser.user.name
    },
    showIntegrationsListSelectionFilter(){
      return this.$store.getShowIntegrationsListSelectionFilter
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.getWindowWidth);
    window.removeEventListener("resize", this.getWindowHeight);
  },
  mounted() { 
    this.showSellsAndReports = this.$route.path.includes('/dashboard');
    const settingsRoutes = [
      '/settingsPos',
      '/settingsV2',
      '/myPayments',
      '/myAccount',
      '/eventsV2',
      '/password',
    ];

    this.showSettings = settingsRoutes.includes(this.$route.path);
    /* eslint-disable */
    const dropdown = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(dropdown);
    /* eslint-enable */

    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowWidth);
      window.addEventListener("resize", this.getWindowHeight);
      // Init
      this.getWindowWidth();
      this.getWindowHeight();

      this.showChangePassword = !this.isAutomaticLogin();
    });
    const userData = localStorage['currentUserData']
    this.userData = JSON.parse(userData)
    if (!this.hasToShowPosTab) return;
    this.organizeMenuOptions()
    const itemsToUpdate = [9, 10, 11, 3, 1]; 
    this.options.forEach(option => {
      if (itemsToUpdate.includes(option.id)) {

        option.show = this.hasToShowPosTab;

        // Reglas específicas para IDs
        this.updateOptionVisibilityPos(option);
      }
    });
  },
  methods: {
    updateOptionVisibilityPos(option) {

    if ([1, 3].includes(option.id)) {
      option.show = false;
    }

    // Regla para ID 10
    if (option.id === 10 && option.show) {
      const optionToHide = this.options.find(opt => opt.id === 5);
      if (optionToHide) {
        optionToHide.show = false;
      }
    }

    // Regla para ID 11
    if (option.id === 11 && option.show) {
      const optionToHide = this.options.find(opt => opt.id === 0);
      if (optionToHide) {
        optionToHide.show = false;
      }
    }
  },
    organizeMenuOptions() {
      const priorityOrder = ['PDV', 'CAJA'];

      return this.options.sort((a, b) => {
        const aIndex = priorityOrder.indexOf(a.title);
        const bIndex = priorityOrder.indexOf(b.title);

        // Elementos no encontrados tienen menor prioridad (se ordenan al final)
        return (aIndex !== -1 ? aIndex : Infinity) - (bIndex !== -1 ? bIndex : Infinity);
      });
    },
    showGeneralFilter() {
      this.hasToShowGeneralFilter = !this.hasToShowGeneralFilter;
    },
    applyDate() {
      let tab = this.tabsFilter.find((item) => {
        return item.title === "Personalizado";
      });

      tab.param = `ConfigurablePeriod${this.dateOne !== "" ? "&From=" + this.dateOne : ""
        }${this.dateTwo !== "" ? "&Until=" + this.dateTwo : ""}`;
      this.changeTab(tab);
      this.formatDates(this.dateOne, this.dateTwo);
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
      if (this.windowWidth <= 991) {
        // this.mobile = true
        setTimeout(() => {
          $(".dropdown-trigger").unbind("click");
          //$(".dropdown-trigger").dropdown();
          /* eslint-disable */
          var dropdown = document.getElementsByClassName("dropdown-trigger");
          var instance = M.Dropdown.init(dropdown);
          //instance.open();
          /* eslint-enable */
        }, 1000);
      } else {
        // this.mobile = false
      }
    },
    getWindowHeight() {
      this.windowHeight = document.documentElement.clientHeight;
    },
    isActive(item) {
      if (this.$route.path === item.url) {
        return true;
      }

      if (item.childs) {
        return item.childs.some((child) => this.$route.path === child.url)
      }

      return false;
    },
  },
  watch: {
    drawer(val) {
      if (!val && !this.$route.path.includes('/dashboard')) {
        this.showSellsAndReports = false;
      }
    },
    // FIXME agregar que este abierto el menu, siempre que estamos en la ruta de dashboard
    '$route.path'(newPath) {
       // Mostrar ventas y reportes si está en /dashboard
        this.showSellsAndReports = newPath.includes('/dashboard');
        
        // Mostrar configuración si la ruta coincide con alguna de las deseadas
        const settingsRoutes = [
          '/settingsPos',
          '/settingsV2',
          '/myPayments',
          '/myAccount',
          '/eventsV2',
          '/password',
        ];

        this.showSettings = settingsRoutes.includes(newPath);
    }
  },
  setup() {
    const { isNotPdsUsers } = useRoles();
    
    return {
      isNotPdsUsers
    };
  }
};
</script>
<style lang="scss">
.headerBistro {
  display: flex;
}


.mobile-filter-applied {
  background-color: #37c866 !important;
}


@media (max-width: 600px) {
  .headerMobile-container {
    display: flex;
    justify-content: space-between;
  }
  
  .logogroup .logo {
    width: 6rem;
  }
  
  .main-header {
    padding: 0.8rem !important;
  }

  .height-without-comerce-selector {
    height: 6rem !important;
  }
  
  .aselect{
    width: 100% !important;
    height: auto !important;
    margin: 1rem 0 0 !important;
    
  }

  .selector {
    border-radius: 4px !important;
  }
  
  .selector .merchant-filter {
    padding: 5px 30px 5px 5px !important;
    h4 {
      font-size: 1rem;
    }
    
  }

  .icon-menu-white {
    width: 20px;
    height: 20px;
    background: #fff;
    mask: url('@/assets/img/icon-menu.svg') no-repeat center;
    -webkit-mask: url('@/assets/img/icon-menu.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask-size: contain;
  }

  .drawer {
    top: 1rem !important;
    right: 1rem;
    color:white;
  }

  .activeNav {
    width: 100%;
    top: 7.5rem !important;
    background: $darkColorBg !important;
    z-index: 99 !important;
  }

  .li-children{
    background-color: white;
    width: 100%;
    display: flex;
    justify-content: center;
      p {
        color: $darkColorBg !important;
      }
  }

  .li-children-active {
    p {
      color: $primaryColor !important; 
    }
    a {
      color: $primaryColor !important; 
    }
  }

  .config-container {
    display: flex;
    gap: 10px;
    margin-top: 2rem;
    img {
      width: 2rem;
      height: 2rem;
    }

    p {
      padding: 0 !important;
    }
  }

  .headerActive p {
    color: $primaryColor !important; 
  }

  .headerMobile .headerOptions{
		padding: 0.5em 0 0 0 !important;
  }

  .submenu {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
